<template>
   <div class="page bg" 
    :class="PdftStore.fromData.questionnaireInfo?.grade == 1
    ? 'qingtong'
    : PdftStore.fromData.questionnaireInfo?.grade == 2
    ? 'baiyin'
    : PdftStore.fromData.questionnaireInfo?.grade == 3
    ? 'huangjin'
    : PdftStore.fromData.questionnaireInfo?.grade == 4
    ? 'baijin'
    : PdftStore.fromData.questionnaireInfo?.grade == 5
    ? 'zuanshi'
    : ''
    "
   >
        <!-- <div class="title">
            ACNAC
        </div> -->
        <div class="title_t">Carbon Neutrality Rating Report</div>
        <div class="line_txt"></div>
        <!-- 白线 -->
        <div class="line"></div>
        <!-- 认证图标 -->
        <div class="r_img"
        :class="PdftStore.fromData.questionnaireInfo?.grade == 1
        ? 'qingtong_logo'
        : PdftStore.fromData.questionnaireInfo?.grade == 2
        ? 'baiyin_logo'
        : PdftStore.fromData.questionnaireInfo?.grade == 3
        ? 'huangjin_logo'
        : PdftStore.fromData.questionnaireInfo?.grade == 4
        ? 'baijin_logo'
        : PdftStore.fromData.questionnaireInfo?.grade == 5
        ? 'zuanshi_logo'
        : ''
        "
        >
            <div class="img_txt">
                <div class="txt_y">{{formatDateTimeYYs(PdftStore.fromData.questionnaireInfo?.evaluationDate)}}</div>
                <div class="top">Top</div>
                <div class="txt_n">{{PdftStore.fromData.questionnaireInfo?.top ? PdftStore.fromData.questionnaireInfo?.top : 0}}%</div>
                <RadianText :name="'arctext1'"/>
            </div>
        </div>

        <!-- 公司信息 -->
        <div class="company">
            <div class="felx">
                <div class="f_txt width">Company Rated : </div>
                <div class="f_txt1">{{PdftStore.fromData.orgInfo?.orgName}}</div>
            </div>

            <div class="mg_b">
                <div class="f_txt width">Reporting Period:</div>
                <div class="f_txt1">{{PdftStore.fromData.questionnaireInfo?.cycle}}</div>
            </div>

            <div class="mg_b">
                <div class="f_txt width">Score:</div>
                <div class="f_txt1" >{{PdftStore.fromData.questionnaireInfo?.score}}</div>
            </div>

            <div class="mg_b">
                <div class="f_txt width">Rating:</div>
                <div class="f_txt1" v-if="PdftStore.fromData.questionnaireInfo?.grade == 1">Bronze</div>
                <div class="f_txt1" v-if="PdftStore.fromData.questionnaireInfo?.grade == 2">Silver</div>
                <div class="f_txt1" v-if="PdftStore.fromData.questionnaireInfo?.grade == 3">Gold</div>
                <div class="f_txt1" v-if="PdftStore.fromData.questionnaireInfo?.grade == 4">Platinum</div>
                <div class="f_txt1" v-if="PdftStore.fromData.questionnaireInfo?.grade == 5">Diamonds</div>
            </div>

            <div class="mg_b">
                <div class="f_txt width">Evaluation Time:</div>
                <div class="f_txt1">{{formatDateTimeYYmms(PdftStore.fromData.questionnaireInfo?.evaluationDate)}}</div>
            </div>

            <div class="mg_b">
                <div class="f_txt width">Location of Headquarters:</div>
                <a-col class="f_txt1" v-if="PdftStore.fromData.orgInfo?.provinceStr && PdftStore.fromData.orgInfo?.cityStr">{{PdftStore.fromData.orgInfo?.provinceStr}},{{PdftStore.fromData.orgInfo?.cityStr}}</a-col>
                <a-col class="f_txt1" v-if="PdftStore.fromData.orgInfo?.provinceStr && !PdftStore.fromData.orgInfo?.cityStr">{{PdftStore.fromData.orgInfo?.provinceStr}}</a-col>
                <a-col class="f_txt1" v-if="!PdftStore.fromData.orgInfo?.provinceStr && PdftStore.fromData.orgInfo?.cityStr">{{PdftStore.fromData.orgInfo?.cityStr}}</a-col>
            </div>

            <div class="mg_b">
                <div class="f_txt width">Company Sector:</div>
                <div class="f_txt1">{{PdftStore.fromData.orgInfo?.subIndustry}}</div>
            </div>

            <div class="mg_b">
                <div class="f_txt width">Company size:</div>
                <div class="f_txt1 t_border" :class="PdftStore.fromData.orgInfo?.orgScale == 1 ? 't_g_b' : ''">S</div>
                <div class="f_txt1 t_border" :class="PdftStore.fromData.orgInfo?.orgScale == 2 ? 't_g_b' : ''">M</div>
                <div class="f_txt1 t_border" :class="PdftStore.fromData.orgInfo?.orgScale == 3 ? 't_g_b' : ''">L</div>
            </div>

            <div class="mg_b">
                <div class="f_txt width">Goal for Achieving Carbon Neutrality(year):</div>
                <div class="f_txt1">{{PdftStore.fromData.questionnaireInfo?.targetYear}}</div>
            </div>
        </div>

        <!-- 白线 -->
        <div class="line_t"></div>

        <!-- logo -->
        <div class="flex_box">
            <div class="flex">

                <!-- <div class="tuv_img">
                    <img src="@/assets/img/ACNAClogo.png" alt="">
                </div> -->
                <div class="car_img">
                    <img src="@/assets/img/Mvgx02_18.png" alt="">
                </div>
                <div class="tuvlogo_box">
                    <img src="@/assets/img/onelogo.png" alt="">
                </div>
                
            </div>
            
            <div class="logo_txt">
                <div>This report is commissioned by MVGX, verified by </div>
                <!-- <img src="@/assets/img/min_tuv.png" class="img_min" alt=""> -->
                <div> TÜV SÜD, powered by Zeepson. </div>
            </div>
        </div>
   </div>
</template>

<script>
import { reactive, toRefs, onBeforeMount, onMounted, components } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import { usePdftStore } from '@/store/pdf'
import { formatDateTimeYYmm, formatDateTimeYY } from '@/utils/date'
import RadianText from '@/components/radianText.vue'
export default {
    name: 'page1',
    components:{RadianText},
    setup() {
        const data = reactive({
            qingtong:require('@/assets/img/report_qingtong_bg.png'),
            baiyin:require('@/assets/img/report_baiyin_bg.png'),
            huangjin:require('@/assets/img/report_huangjin_bg.png'),
            baijin:require('@/assets/img/report_baijin_bg.png'),
            zuanshi:require('@/assets/img/report_zuanshi_bg.png'),
        })
        //引入数据管理库
        const PdftStore = usePdftStore()
        const formatDateTimeYYmms = (str) => {
            return formatDateTimeYYmm(str)
        }
        const formatDateTimeYYs = (str) => {
            return formatDateTimeYY(str)
        }
        onBeforeMount(() => {})
        onMounted(() => {})
        return {
            PdftStore,
            formatDateTimeYYmms,
            formatDateTimeYYs,
            ...toRefs(data),
        }
    },
}

</script>
<style scoped lang='less'>
.qingtong{
    background: url('@/assets/img/report_qingtong_bg.png');
}
.baiyin{
    background: url('@/assets/img/report_baiyin_bg.png');
}
.huangjin{
    background: url('@/assets/img/report_huangjin_bg.png');
}
.baijin{
    background: url('@/assets/img/report_baijin_bg.png');
}
.zuanshi{
    background: url('@/assets/img/report_zuanshi_bg.png');
}
.qingtong_logo{
    background: url('@/assets/img/report_qingtong_logo_en.png');
}
.baiyin_logo{
    background: url('@/assets/img/report_baiyin_logo_en.png');
}
.huangjin_logo{
    background: url('@/assets/img/report_huangjin_logo_en.png');
}
.baijin_logo{
    background: url('@/assets/img/report_baijin_logo_en.png');
}
.zuanshi_logo{
    background: url('@/assets/img/report_zuanshi_logo_en.png');
}
.page{
    width: 1512px;
    height: 2149px;
    margin: 0 auto;
    position: relative;
    .title{
        font-size: 110px;
        font-weight: 500;
        color: #FFFFFF;
        padding: 180px 0 0 130px;
        line-height: 113px;
    }
    .title_t{
        font-size: 84px;
        font-weight: 400;
        padding: 180px 0 0 130px;
        // margin-top: 50px;
        color: rgba(255,255,255,0.8);
        font-family: PingFangSC-Medium, PingFang SC !important;
        // padding: 0 0 0 130px;
        line-height: 150px;
    }
    .line_txt{
        margin: 50px 0 0 130px;
        width: 114px;
        height: 1px;
        border-radius: 50px;
        border: 6px solid rgba(255,255,255,0.4);
    }
    .line{
        width: 1383px;
        height: 8px;
        background: #FFFFFF;
        position: absolute;
        top: 35%;
        right: 0;
    }
    .r_img{
        width: 300px;
        height: 300px;
        background-repeat: no-repeat;
        background-size: cover;
        position: absolute;
        top: 28%;
        left: 42%;
        .img_txt{
            position: relative;
            .txt_y{
                font-size: 14px;
                line-height: 0;
                color: #FFFFFF;
                position: absolute;
                top: 110px;
                left: 21px;
                transform: rotateZ(29deg);
            }
            .txt_c{
                font-size: 38px;
                font-weight: 600;
                position: absolute;
                top: 80px;
                left: 90px;
                color: #00DF9F;
            }
            .top{
                font-size: 14px;
                line-height: 0;
                color: #FFFFFF;
                position: absolute;
                top: 170px;
                right: 17px;
                transform: rotateZ(27deg);
            }
            .txt_n{
                font-size: 14px;
                line-height: 0;
                font-weight: 600;
                color: #FFFFFF;
                position: absolute;
                // top: 165px;
                // right: 17px;
                top: 190px;
                right: 22px;
                transform: rotateZ(30deg);
            }
        }
    }
    .company{
        margin-top: 650px;
        padding-left: 129px;
        .mg_b{
            margin-bottom: 50px;
            display: flex;
        }
        .felx{
            display: flex;
            margin-bottom: 50px;
            .f_txt{
                font-size: 32px;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 30px;
            }
            .f_txt1{
                font-size: 32px;
                font-weight: 600;
                color: #FFFFFF;
                line-height: 30px;
            }
            
        }
        .f_txt{
            font-size: 26px;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 42px;
        }
        .f_txt1{
            font-size: 32px;
            font-weight: 600;
            color: #FFFFFF;
            line-height: 42px;
        }
        .t_border{
            // padding-bottom:5px;
            margin-right: 15px;
            color: rgba(255,255,255,0.5) !important;
            // border-bottom: 3px solid rgba(255,255,255,0.5);
        }
        .t_g_b{
            color: rgba(255,255,255,1) !important; 
            border-bottom: 3px solid #10b49c;
        }
    }
    .line_t{
        width: 1383px;
        height: 4px;
        background: #FFFFFF;
        opacity: 0.6;
        margin-left: 129px;
        margin-top: 110px;
    }
    .flex_box{
        display: flex;
        padding-left: 129px;
        padding-right: 89px;
        justify-content: space-between;
        .flex{
            display: flex;
        }
        .tuv_img{
            width: 81px;
            height: auto;
            margin-top: 70px;
            margin-right: 32px;
            img{
                width: 100%;
                height: auto;
            }
        }
        .car_img{
            width: 215px;
            height: auto;
            margin-top: 70px;
            
            img{
                width: 100%;
                height: auto;
            }
        }
        .tuvlogo_box{
            width: 81px;
            height: auto;
            margin-top:65px;
            margin-left: 40px;
            img{
                width: 100%;
                height: auto;
            }
        }
        .logo_txt{
            font-size: 14px;
            font-weight: 400;
            color: #FFFFFF;
            text-align: right;
            margin-top: 90px;
            display: flex;
            align-items: center;
            .img_min{
                width: 27px;
                height: 27px;
                margin: 0 5px;
            }
        }
    }
}
.wid{
    max-width: 198px;
}
.width{
    min-width: 590px !important;
}
</style>